function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "wall-clock");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "wall-clock",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#000000",
  fillRule: "nonzero",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10,0 C4.47253906,0 0,4.47292969 0,10 C0,15.5274609 4.47296875,20 10,20 C15.5274609,20 20,15.5270703 20,10 C20,4.47253906 15.5270313,0 10,0 Z M10,18.4375 C5.33621094,18.4375 1.5625,14.6634766 1.5625,10 C1.5625,5.33621094 5.3365625,1.5625 10,1.5625 C14.6637891,1.5625 18.4375,5.33652344 18.4375,10 C18.4375,14.6637891 14.6634375,18.4375 10,18.4375 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3082031,11.6738281 L10.78125,9.55765625 L10.78125,3.75 C10.78125,3.31851563 10.4314844,2.96875 10,2.96875 C9.56851562,2.96875 9.21875,3.31851563 9.21875,3.75 L9.21875,10 C9.21875,10.2744141 9.36273438,10.5287109 9.59804687,10.6699219 L13.5042969,13.0136719 C13.8742578,13.2356641 14.3542188,13.1156641 14.5761328,12.7457031 C14.7981641,12.3757031 14.6782031,11.8958203 14.3082031,11.6738281 Z"
})));

var SvgWallClock = function SvgWallClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wall-clock.e2274ac3.svg";
export { ForwardRef as ReactComponent };